export default "__VITE_ASSET__C_tHIYJ8__"